import { forwardRef, createElement } from 'react';

function IconSubscriptions(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M18.25 2c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0118.25 22H13l-.001-1.5h5.251a.25.25 0 00.243-.193l.007-.057V3.75a.25.25 0 00-.193-.243L18.25 3.5H5.75a.25.25 0 00-.243.193L5.5 3.75 5.499 13H4V3.75C4 2.784 4.784 2 5.75 2h12.5zM4.142 16.956a.5.5 0 01.55-.147l.082.038 2.143 1.237.074.052a.5.5 0 01.147.55l-.038.081-.052.074a.5.5 0 01-.55.147l-.081-.038-.878-.505a2.5 2.5 0 004 1.525.75.75 0 11.925 1.181 4.002 4.002 0 01-6.343-2.173l-.402.695-.052.074a.5.5 0 01-.852-.492l.038-.082 1.238-2.143.051-.074zM8 14a4.001 4.001 0 013.92 3.197l.358-.62a.5.5 0 01.6-.221l.083.038a.5.5 0 01.22.601l-.037.082-1.238 2.143a.5.5 0 01-.6.221l-.083-.038-2.143-1.237a.5.5 0 01.418-.904l.082.038.914.528a2.5 2.5 0 00-4.033-1.798.75.75 0 11-.925-1.181A3.985 3.985 0 018 14zm7.75-1a.75.75 0 110 1.5h-2.5a.75.75 0 110-1.5h2.5zm0-3.5a.75.75 0 110 1.5h-7.5a.75.75 0 110-1.5h7.5zm0-3.5a.75.75 0 110 1.5h-7.5a.75.75 0 010-1.5h7.5z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var Subscriptions = /*#__PURE__*/forwardRef(IconSubscriptions);

export default Subscriptions;
//# sourceMappingURL=Subscriptions.js.map
